import React, { useEffect, useCallback } from "react"
import { reduxForm, submit, reset, Field, getFormValues } from "redux-form"
import { connect } from "react-redux"
import { Box } from "@infotech/uikit-grid"
import FieldSet from "@infotech/uikit-fieldset"
import FilterModal from "src/components/FilterModal"
import get from "lodash/get"
import allPlanTypes from "src/hocs/allPlanTypes"
import Select from "src/components/Selects/Select"
import DateRangePicker from "src/components/DateRangePicker"
import trim from "lodash/trim"
import TagsInput from "src/components/TagsInput"
import styles from "./styles.css"

const FORM_NAME = `planFilter`
const selectValues = getFormValues(FORM_NAME)

const PlanTypesField = allPlanTypes()(({ planTypes: { data } }) => (
  <Field
    component={Select}
    name="planTypeId"
    placeholder="Выберите тип плана"
    options={data.map(item => ({
      value: item.id,
      label: item.name,
    }))}
    isClearable
  />
))

const PlanDateRangeField = () => (
  <Field component={DateRangePicker} name="range" />
)

const PlanFilterFormComponent = props => {
  const { isOpen, dirty, onCancel, dispatch, query, modelName, tags } = props
  const handleSubmit = () => {
    dispatch(submit(FORM_NAME))
  }

  const resetForm = useCallback(() => dispatch(reset(FORM_NAME)), [])

  const handleCancel = useCallback(() => {
    resetForm()
    onCancel()
  }, [])

  useEffect(() => {
    if (!query) {
      resetForm()
    }
  }, [query])

  return (
    <FilterModal
      modelName={modelName}
      isOpen={isOpen}
      onOk={handleSubmit}
      onCancel={handleCancel}
      width={440}
      dirty={dirty}
      invalid={false}
      title="Фильтр планов"
    >
      <Box p="2md">
        <form>
          <FieldSet caption="Тип плана">
            <PlanTypesField />
          </FieldSet>
          <FieldSet className={styles.RangePicker} caption="Период плана">
            <PlanDateRangeField />
          </FieldSet>
          <Box loose pt="2md">
            <FieldSet caption="Теги">
              <Field name="tags" component={TagsInput} tagsArray={tags} />
            </FieldSet>
          </Box>
        </form>
      </Box>
    </FilterModal>
  )
}

const queryToValues = rsqlQuery => {
  if (!rsqlQuery) {
    return null
  }
  const planTypeIdRegex = /;?planTypeId=in=\((?<planTypeId>\d+)\);?/gi
  const planTypeId = parseInt(
    trim(get(planTypeIdRegex.exec(rsqlQuery), `groups.planTypeId`, ``), `;`) ||
      -1,
    10,
  )

  const tagsRegex = /;?tags=in=\((?<tags>\S+)\);?/gi
  const tags = trim(get(tagsRegex.exec(rsqlQuery), `groups.tags`, ``), `;`)
    .split(`,`)
    .filter(str => str.length > 0)

  const startDateTimeRegex = /startDateTime=lt=(?<startDateTime>\d+);?/gi
  const startDateTime = parseInt(
    trim(
      get(startDateTimeRegex.exec(rsqlQuery), `groups.startDateTime`, ``),
      `;`,
    ) || -1,
    10,
  )

  const endDateTimeRegex = /endDateTime=gt=(?<endDateTime>\d+);?/gi
  const endDateTime = parseInt(
    trim(
      get(endDateTimeRegex.exec(rsqlQuery), `groups.endDateTime`, ``),
      `;`,
    ) || -1,
    10,
  )

  const range = [
    startDateTime >= 0 ? endDateTime : undefined,
    endDateTime >= 0 ? startDateTime : undefined,
  ]

  return {
    planTypeId: planTypeId > 0 ? planTypeId : undefined,
    tags: tags.length > 0 ? tags : undefined,
    range,
  }
}

const valuesToQuery = values => {
  const queryParts = []

  if (values.planTypeId) {
    // find related part
    queryParts.push(`planTypeId=in=(${values.planTypeId})`)
  }

  if (get(values, `tags.length`) > 0) {
    // find related part
    queryParts.push(`tags=in=(${values.tags.join(`,`)})`)
  }

  const startDateTime = get(values, `range[0]`)
  const endDateTime = get(values, `range[1]`)
  if (endDateTime) {
    queryParts.push(`startDateTime=lt=${endDateTime}`)
  }
  if (startDateTime) {
    queryParts.push(`endDateTime=gt=${startDateTime}`)
  }

  return queryParts.join(`;`)
}

const PlanFilterForm = reduxForm({
  onSubmit: (values, dispatch, props) => {
    props.onOk(valuesToQuery(values))
  },
  enableReinitialize: true,
  form: FORM_NAME,
})(PlanFilterFormComponent)

const ConnectedPlanFilterForm = connect(
  (state, props) => ({
    initialValues: queryToValues(props.query),
    tags: get(selectValues(state), `tags`) || [],
  }),
  null,
)(PlanFilterForm)

export default ConnectedPlanFilterForm
